import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { GridApi, GridOptions, IDatasource, IGetRowsParams } from 'ag-grid-community';
import { url } from 'inspector';
import { GenericFilter } from 'projects/shared/src/lib/models/GenericFilter';

import { LegacySquirrelUserDto, UserListMigrationResponse } from 'projects/shared/src/lib/models/LegacySquirrelUser';
import { SquirrelEnvironmentDto } from 'projects/shared/src/lib/models/SquirrelEnvironmentDto';
import { DatabaseMigrationService } from 'projects/shared/src/lib/services/database-migration.service';
import { LegacySquirrelService } from 'projects/shared/src/lib/services/legacy-squirrel.service';
import { NotificationService } from 'projects/shared/src/lib/services/notification.service';
import { TranslateService } from 'projects/shared/src/lib/services/translate.service';
import { ErrorFormat } from 'projects/shared/src/lib/util/error-format';
import { AgGridSquirrelEnvironmentSettings } from './AgGridSquirrelEnvironmentSettings';
import { project_sample_data_1, user_sample_data_1, user_sample_data_2 } from './sample-data';
import { SquirrelEnvironmentButtonRendererComponent } from './squirrel-environment-button-renderer/squirrel-environment-button-renderer.component';
import { TenantDto } from 'projects/shared/src/lib/models/TenantDto';
import { TenantService } from 'projects/shared/src/lib/services/tenant.service';


@Component({
  selector: 'database-migrations',
  templateUrl: './database-migrations.component.html',
  styleUrls: ['./database-migrations.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class DatabaseMigrationsComponent implements OnInit {

  squirrelEnvironmentForm!: FormGroup;  

  errorMessage!: string;
  databaseVersion!: number;
  unMigratedUsers!: number;
  migrationError!: string;
  // selectedEnvironment!: string;
  selectedEnvironment!: SquirrelEnvironmentDto;
  selectedEnvironmentTenant!: TenantDto;
  mailingCount!:number;

  legacySquirrelUserDtos: LegacySquirrelUserDto[] = [];

  rowData: SquirrelEnvironmentDto[] = [];
  rowDataTenant: TenantDto[] = [];
  ds!: IDatasource;
  gridApi!: GridApi;
  gridOptions!: GridOptions;
  frameworkComponents: any;
  filter!: GenericFilter;
  aggridSettings!:AgGridSquirrelEnvironmentSettings;
  public overlayLoadingTemplate = '<span class="ag-overlay-loading-center">Please wait while your rows are loading</span>';

  resultsLength = 0;
  isLoadingResults = true;
  isRateLimitReached = false;

  ul: LegacySquirrelUserDto[] = [];
  
  constructor(private formBuilder: FormBuilder,
    private databaseMigrationService: DatabaseMigrationService,
    private legacySquirrelService: LegacySquirrelService,
    public translate: TranslateService,
    private tenantService: TenantService,
    private notificationService: NotificationService,
  ) { }

  ngOnInit(): void {

    this.createSquirrelEnvironmentForm();

    this.filter = new GenericFilter();

    this.aggridSettings = new AgGridSquirrelEnvironmentSettings(this.translate);

    this.frameworkComponents = {
      buttonRenderer: SquirrelEnvironmentButtonRendererComponent
    }

   this.gridOptions = this.aggridSettings.agGridSquirrelEnvironmentSettings;
    
    this.refresh();
    this.getSquirrelEnvironments();
    this.getTenants();
   // this.getEmailDataCount();
  }

  onGridReady(params: any) {
    this.gridApi = params.api;
    this.gridApi.sizeColumnsToFit();
    this.gridApi.setDatasource(this.ds)
  }

  getTenants() {
    this.tenantService.getTenants(this.filter).subscribe({
      next: (tenants) => {
        this.rowDataTenant = tenants;
        // this.rowData = this.rowData.slice(params.startRow, params.endRow);
        // let lastRow = -1;

        // if (tenants.length <= params.endRow) {
        //   lastRow = tenants.length;
        // }
        // params.successCallback(this.rowData, lastRow);
        // this.isLoadingResults = false;
        // this.isRateLimitReached = false;
        // this.resultsLength = this.rowData.length;

        // this.gridApi.hideOverlay();

      },
      error: (error: any) => {
        this.isLoadingResults = false;
        this.isRateLimitReached = true;
        this.notificationService.error(`${this.translate.data["ERROR"]}`, `${this.translate.data["TENANTRETRIVALERROR"]}`)
      }
    });

  }

  getSquirrelEnvironments() {
    this.ds = {
      rowCount: 0,
      getRows: (params: IGetRowsParams) => {
        this.filter.className = 'SquirrelEnvironment';
        this.filter.startRow = params.startRow;
        this.filter.endRow = params.endRow;
        this.filter.sortItems = params.sortModel;
        this.filter.clientFilters = params.filterModel;

        this.gridApi.showLoadingOverlay();
        this.isLoadingResults = true;

        this.databaseMigrationService.getSquirrelEnvironments(this.filter).subscribe({
          next: (data) => {
            this.rowData = data.slice(this.filter.startRow, this.filter.endRow);
            let lastRow = -1;

            if (this.rowData.length <= this.filter.endRow) {
              lastRow = this.rowData.length;
            }
            params.successCallback(this.rowData, lastRow);

            this.isLoadingResults = false;
            this.isRateLimitReached = false;
            this.resultsLength = this.rowData.length;

            this.gridApi.hideOverlay();
            //this.notificationService.info(`${this.translate.data["INFO"]}`, `${this.translate.data["ENVIRONMENTSRETRIEVED"]}`);
          },
          error: (error: any) => {
            this.isLoadingResults = false;
            // Catch if the Squirrel API has reached its rate limit. Return empty data.
            this.isRateLimitReached = true;
            this.notificationService.error(`${this.translate.data["ERROR"]}`, `${this.translate.data["ENVIRONMENTSRETRIVALERROR"]}`)
          }
        });
      }
    }
  }

  createSquirrelEnvironmentForm() {
    this.squirrelEnvironmentForm = this.formBuilder.group({
      url: [null, Validators.required]
    });
  }

  refresh() {
    this.databaseMigrationService.getCurrentVersion().subscribe({
      next: (version: any) => {
        this.databaseVersion = version;
        console.log(this.databaseVersion)
      },
      error: (error: any) => this.errorMessage = ErrorFormat.formatError(error)
    });
  }

  migrateMainDatabase() {
    this.databaseMigrationService.executeMainDbSqlQueries().subscribe({
      next: (data: any) => {
        console.log(data)
      },
      error: (error: any) => this.errorMessage = ErrorFormat.formatError(error)
    });
  }

  migrateGenericDatabases() {
    this.databaseMigrationService.executeGenericDbsQueries().subscribe({
      next: (data: any) => {
        console.log(data)
      },
      error: (error: any) => this.errorMessage = ErrorFormat.formatError(error)
    });
  }

  migrateUsers() {

    if (this.selectedEnvironment != null && this.selectedEnvironmentTenant != null &&
       this.selectedEnvironment.apiUrl !== undefined && this.selectedEnvironment.apiUrl !== "" &&
        this.selectedEnvironmentTenant.name !== undefined && this.selectedEnvironmentTenant.name !== "") {

      this.legacySquirrelService.getLegacySquirrelUsers(this.selectedEnvironment.apiUrl).subscribe({
        next: (userListMigrationResponse: UserListMigrationResponse) => {
          console.log("---------------------------> Users to migrate: ", userListMigrationResponse);

          this.unMigratedUsers = userListMigrationResponse.UnMigratedUsers;
          this.migrationError = userListMigrationResponse.Error;
          this.notificationService.info(`${this.translate.data["INFO"]}`, `${this.translate.data["FETCHEDLEGACYUSERS"]} :: ${userListMigrationResponse.Users.length}`);
          if (this.selectedEnvironment.apiUrl.length > 0 && userListMigrationResponse.Users.length > 0) {
            this.databaseMigrationService.migrateLegacySquirrelUsers(this.selectedEnvironment.url, this.selectedEnvironmentTenant.name, this.selectedEnvironmentTenant.id, userListMigrationResponse.Users).subscribe({
              next: (data) => {
                console.log("---------------------------> migrated Users: ", data);
                this.notificationService.info(`${this.translate.data["INFO"]}`, `${this.translate.data["MIGRATEDLEGACYUSERS"]} :: ${data.length}`);
                this.legacySquirrelService.postMigratedUserInfo(data, this.selectedEnvironment.apiUrl).subscribe({
                  next: (data) => {
                    this.notificationService.info(`${this.translate.data["INFO"]}`, `${this.translate.data["POSTMIGRATEDLEGACYUSERS"]}`);
                  },
                  error: (error: any) => this.notificationService.error(`${this.translate.data["ERROR"]}`, `${this.translate.data["POSTMIGRATEDUSERINFOERROR"]}`)
                });
              },
              error: (error: any) => this.notificationService.error(`${this.translate.data["ERROR"]}`, `${this.translate.data["MIGRATELEGACYUSERSERROR"]}`)
            });
          }
          else {
            // this.notificationService.info(`${this.translate.data["INFO"]}`, `${this.translate.data["NOLEGACYUSERS"]} :: ${this.selectedEnvironment}`)
            this.notificationService.info(`${this.translate.data["INFO"]}`, `${this.translate.data["NOLEGACYUSERS"]}`)
          }
        },
        error: (error: any) => {
          this.notificationService.error(`${this.translate.data["ERROR"]}`, `${this.translate.data["FETCHLEGACYUSERERROR"]}`);
          console.log("----------> error: ", error.error.Error)
          this.notificationService.info("",error.error.Error)
        }
      });

    } else {
      this.notificationService.info(`${this.translate.data["INFO"]}`, `Environment and/or Tenant not selected!`)
    }
  }

  migrateProjects() {
 
    if (this.selectedEnvironment != null && this.selectedEnvironmentTenant != null &&
      this.selectedEnvironment.apiUrl !== undefined && this.selectedEnvironment.apiUrl !== "") {

      this.legacySquirrelService.getLegacySquirrelProjects(this.selectedEnvironment.apiUrl).subscribe({
        next: (legacyProjectToMigrateDtos) => {
          this.notificationService.info(`${this.translate.data["INFO"]}`, `${this.translate.data["FETCHEDLEGACYPROJECTS"]} :: ${legacyProjectToMigrateDtos.length}`);
          if (this.selectedEnvironment.apiUrl.length > 0 && legacyProjectToMigrateDtos.length > 0) {
            console.log("--------> migrateLegacySquirrelProjects: projects = ",legacyProjectToMigrateDtos);
            this.databaseMigrationService.migrateLegacySquirrelProjects(this.selectedEnvironment.url, this.selectedEnvironmentTenant.name, legacyProjectToMigrateDtos).subscribe({
              next: (data) => {
                console.log("confirm project migration - data = ",data);
                this.notificationService.info(`${this.translate.data["INFO"]}`, `${this.translate.data["MIGRATEDLEGACYPROJECTS"]} :: ${data.length}`);
                this.legacySquirrelService.postMigratedProjectInfo(data, this.selectedEnvironment.apiUrl).subscribe({
                  next: (data) => {
                    // this.notificationService.info(`${this.translate.data["INFO"]}`, `${this.translate.data["POSTEDLEGACYPROJECTS"]} :: ${data.length}`);
                    this.notificationService.info(`${this.translate.data["INFO"]}`, `${this.translate.data["POSTEDLEGACYPROJECTS"]}`);
                  },
                  error: (error: any) => this.notificationService.error(`${this.translate.data["ERROR"]}`, `${this.translate.data["POSTMIGRATEDPROJECTINFOERROR"]}`)
                });
              },
              error: (error: any) => this.notificationService.error(`${this.translate.data["ERROR"]}`, `${this.translate.data["MIGRATELEGACYPROJECTSERROR"]}`)
            });
          }
          else {
            // this.notificationService.info(`${this.translate.data["INFO"]}`, `${this.translate.data["NOLEGACYPROJECTS"]} :: ${this.selectedEnvironment}`);
            this.notificationService.info(`${this.translate.data["INFO"]}`, `${this.translate.data["NOLEGACYPROJECTS"]}`);
          }
        },
        error: (error: any) => {
          this.notificationService.error(`${this.translate.data["ERROR"]}`, `${this.translate.data["FETCHLEGACYPROJECTSERROR"]}`);
          console.log("----------> error: ", error.error)
          this.notificationService.info("",error.error)

        }
      });

    } else {
      this.notificationService.info(`${this.translate.data["INFO"]}`, `Environment and/or Tenant not selected!`)
    }
  }

  // getEmailDataCount() {
  //   this.databaseMigrationService.getEmailDataCount(this.selectedEnvironment).subscribe({
  //     next:(count:number) => {
  //       this.mailingCount = count;
  //     }
  //   })
  // }

  sendEmail() {

    if(this.selectedEnvironment.url !== undefined && this.selectedEnvironment.url !== "") {
    
      this.databaseMigrationService.SendMail(this.selectedEnvironment.url).subscribe({
        next: (x:any) => {
          if(x !== 0) {
            this.notificationService.info(`${this.translate.data["INFO"]}`, `${this.translate.data["USERPROJECTSMIGRATEDEMAIL"]} : ${x}`);
          }
          else{
            this.notificationService.info(`${this.translate.data["INFO"]}`, `${this.translate.data["NOUSERPROJECTSMIGRATEDEMAIL"]} : ${x}`);
          }         
        },
        error: (eror: any) => this.notificationService.error(`${this.translate.data["ERROR"]}`, `${this.translate.data["USERPROJECTSMIGRATEDEMAILERROR"]}`)
      });    
    }

  }

  addSquirrelEnvironment() {
    
    if(this.squirrelEnvironmentForm.valid) {
      
      let name:string = this.squirrelEnvironmentForm.value.url;          
      let url = new URL(this.squirrelEnvironmentForm.value.url);

      name = name.split("/")[2];

      let squirrelEnvironmentDto =  new SquirrelEnvironmentDto;
      squirrelEnvironmentDto.name = name;
      // squirrelEnvironmentDto.apiUrl = this.squirrelEnvironmentForm.value.url;    
      squirrelEnvironmentDto.apiUrl = url.origin + '/';
      squirrelEnvironmentDto.url = url.origin;

      this.databaseMigrationService.createSquirrelEnvironment(squirrelEnvironmentDto).subscribe({
        next:(environment) => {
          this.rowData.splice(2, 0, environment);
          this.rowData.push(environment);
          this.gridApi.refreshInfiniteCache();
          this.notificationService.info(`${this.translate.data["INFO"]}`, `${this.translate.data["ENVIRONMENTADDED"]}`);
        },
        error: (eror: any) => this.notificationService.error(`${this.translate.data["ERROR"]}`, `${this.translate.data["ENVIRONMENTADDEDERROR"]}`)
      })
    }

  }
}
